module.exports = __webpack_public_path__ + "img/phattai68Logo.94cdc18b.png";